<template>
	<section>
		<div class="special-offer" :class="{ 'special-offer--margin-bottom': props.marginBottom }">
			<div class="special-offer__info" data-aos="fade-up">
				<h3 class="special-offer__title">{{ $t('modules.long_term_page_module.long_term_page_special_offer.check_our_special_offer') }}</h3>
				<Transition name="fade">
					<div v-if="offer" class="special-offer__timer">
						<span>{{ timeLeft.hours }} {{ $t('modules.long_term_page_module.long_term_page_special_offer.hours_left') }}</span>
						<span class="special-offer__timer-dots">:</span>
						<span>{{ timeLeft.minutes }} {{ $t('modules.long_term_page_module.long_term_page_special_offer.minutes_left') }}</span>
						<span class="special-offer__timer-dots">:</span>
						<span>{{ timeLeft.seconds }} {{ $t('modules.long_term_page_module.long_term_page_special_offer.seconds_left') }}</span>
					</div>
				</Transition>
				<div class="special-offer__car">
					<TransitionGroup name="fade" mode="out-in">
						<LongTermPageSpecialOfferCar
							v-if="offer"
							:car="offer.product"
							:discountPercentage="discountPercentage"
							:min-val="props.minVal"
							:max-val="props.maxVal"
							:type="props.type"
							:label="props.label"
							:timeframe="props.timeframe" />
						<v-progress-circular
							v-else
							indeterminate
							color="var(--primary-color)"
							size="70"
							:width="6"
							class="special-offer__progress-circular" />
					</TransitionGroup>
				</div>
			</div>

			<div style="position: relative" data-aos="fade-up" data-aos-delay="200">
				<GlobalImage class="special-offer__image" :src="props.image" alt="Special offer image" :width="1224" />
				<div class="special-offer__image-circle">
					<span>{{ $t('modules.long_term_page_module.long_term_page_special_offer.only_today') }}</span>
				</div>
			</div>
		</div>
	</section>
</template>
<script setup lang="ts">
const props = defineProps<{
	marginBottom?: boolean
	type: ESpecialDailyOfferType
	image: string
	minVal: number
	maxVal: number
	label?: EFormLabel
	timeframe?: EContactFormRentalTimeframe
}>()
const offer = ref<ISpecialDailyOffersModel | null>(null)
const discountPercentage = ref<number>()
const endDate = ref()
const timeLeft = ref()

const getSpecialOffer = async () => {
	try {
		const response = await ApiService.fetchSpecialDailyOffer(props.type)
		return response
	} catch (error) {
		console.error(error)
	}
}

function calculateTimeLeft() {
	const now = new Date()

	const difference = endDate.value.valueOf() - now.valueOf()

	if (difference <= 0) {
		return {
			hours: 0,
			minutes: 0,
			seconds: 0,
		}
	}

	const hours = Math.floor(difference / (1000 * 60 * 60))
	const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))
	const seconds = Math.floor((difference % (1000 * 60)) / 1000)

	return {
		hours,
		minutes,
		seconds,
	}
}

const setData = async () => {
	const response = await getSpecialOffer()

	if (response?.createdAt && new Date(response.createdAt) < new Date(new Date().getTime() - 1 * 24 * 60 * 60 * 1000)) {
		return
	}

	if (response) {
		endDate.value = new Date(new Date(response.createdAt).getTime() + 1 * 24 * 60 * 60 * 1000)

		timeLeft.value = calculateTimeLeft()
		discountPercentage.value = response.discountPercentage
		offer.value = response
	}
}
onMounted(() => {
	setData()
})

useIntervalFn(() => {
	if (!endDate.value) return
	timeLeft.value = calculateTimeLeft()
}, 1000)
</script>
<style scoped lang="scss">
@import './LongTermPageSpecialOffer.scss';
</style>
